import React from 'react';
import { Button } from 'react-bootstrap';

const VMNav = ({ showBack, showSkip, showSubmit, back, skip, submit, type }) => {

  return (
    <div className={`vm-nav ${showSubmit && 'vm-nav-margin'}`} style={{width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'center', transition: 'all 0.5s'}}>
      {
        showBack &&
          <div>
          <Button className="btn-virtual-message vm-navigate vm-navigate-back pull-left" onClick={back}>
            <i className="fa fa-arrow-left vm-title-arrow"/>
            <span>Back</span>
          </Button>
          </div>
      }
      <div style={{flexGrow: '1'}}></div>
      {
        showSkip &&
          <div className="vm-navigate pull-right" style={{textAlign: 'right'}} onClick={skip}>
            <span style={{color: '#E58282'}}>Skip and submit</span>
          </div>
      }
      {
        type !== 'youtube' && showSubmit &&
          <div className="vm-disclaimer">
            <input readOnly="true" type="checkbox" style={{marginRight: '5px'}} checked="true"/>
I, hereby, declare and confirm that I am the rightful owner and I am authorised to use the media that I have uploaded and it does not contain any prohibited, sensitive or illegal content/information.
          </div>
      }
      {
        showSubmit &&
          <div>
          <Button className="btn-virtual-message vm-done pull-right" onClick={submit}>
            {
              type !== 'youtube' ?
                <span>Agree &<br/>Upload</span>
                :
                <span>Submit</span>
            }
            <i className="fa fa-arrow-right vm-done-arrow"></i>
          </Button>
          </div>
      }
    </div>
  )
}

export default VMNav;
